export const defaultConfig = {
    color: "grey",
    icon: "circle-filled",
    filled: false,
    neutralText: false
};

// always use a specific prefix for the keys,
// so that we can differentiate between the different types of statuses from different contexts
export const statusTypes: StatusProps = {
    SHIPMENT_in_progress: {
        color: "orange"
    },
    SHIPMENT_sent: {
        color: "dark-blue"
    },
    SHIPMENT_invoiced: {
        color: "green"
    },
    MISSION_CREATED: {}, // all default values
    MISSION_PLANNED: {
        color: "orange"
    },
    MISSION_PROPOSED: {
        color: "orange"
    },
    MISSION_CONFIRMED: {
        color: "dark-blue" // this is defined as a different shade of blue in confluence, that does not exist in ux.ui
    },
    MISSION_TECHNICIAN_SCHEDULED: {
        color: "dark-blue"
    },
    MISSION_COMPLETED: {
        color: "green"
    },
    SERVICE_CALL_TransactionFailed: {
        color: "red"
    },
    SERVICE_CALL_Open: {
        color: "dark-blue"
    },
    SERVICE_CALL_Deleted: {
        color: "red"
    },
    SERVICE_CALL_Closed: {
        color: "green"
    },
    SERVICE_CALL_WaitingForCustomer: {}, // all default values
    SERVICE_CALL_InProcess: {}, // all default values
    "SERVICE_CALL_call-predictive": {
        color: "dark-blue"
    },
    SERVICE_CALL_NewTechMessage: {
        // @deprecated use SERVICE_CALL_UnreadChatMessages instead
        deprecated: true,
        color: "orange"
    },
    SERVICE_CALL_UnreadChatMessages: {
        color: "orange"
    },
    SERVICE_CALL_OrderNumberRequired: {
        color: "orange"
    },
    SERVICE_AGREEMENT_Active: {
        icon: "circle-checkmark",
        filled: true,
        color: "green",
        neutralText: true
    },
    SERVICE_AGREEMENT_Inactive: {
        icon: "circle-cross",
        color: "red",
        filled: true,
        neutralText: true
    },
    SOFTWARE_UPDATES_SUBSCRIBED: {
        color: "green"
    },
    SOFTWARE_UPDATES_UPDATE_AVAILABLE: {
        color: "orange"
    },
    SOFTWARE_UPDATES_INSTALLATION_FAILED: {
        color: "red"
    },
    SOFTWARE_UPDATES_UNSUBSCRIBED: {}, // all default values
    SOFTWARE_UPDATES_NOT_AVAILABLE_FOR_SUBSCRIPTION: {}, // all default values
    SOFTWARE_UPDATES_UpdatesNotSubscribed: {},
    SOFTWARE_UPDATES_UpdatesPartiallySubscribed: {
        color: "green"
    },
    SOFTWARE_UPDATES_AllUpdatesSubscribed: {
        color: "green"
    },
    SOFTWARE_UPDATES_WaitingForInstallationOfSecurityUpdate: {
        color: "orange"
    },
    SOFTWARE_UPDATES_WaitingForInstallationOfFunctionalUpdate: {
        color: "orange"
    },
    SOFTWARE_UPDATES_InstallationFailedOfSecurityUpdate: {
        color: "red"
    },
    SOFTWARE_UPDATES_InstallationFailedOfFunctionalUpdate: {
        color: "red"
    },
    ORDER_ORDERED: {
        color: "dark-blue"
    },
    ORDER_IN_PROGRESS: {
        color: "dark-blue"
    },
    ORDER_CANCELLED: {
        color: "red"
    },
    ORDER_PARTLY_SENT: {
        color: "orange"
    },
    ORDER_COMPLETE: {
        color: "green"
    },
    ORDER_RECEIVED: {
        color: "dark-blue"
    },
    ORDER_UNKNOWN: {} // all default values
};

export type StatusType = keyof typeof statusTypes;

export interface StatusProps {
    [key: string]: {
        color?: string;
        icon?: string;
        filled?: boolean;
        neutralText?: boolean;
        deprecated?: boolean;
    };
}
